import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {OAuthCallbackParams, UserFinalizeResponse} from '@guestapp/sdk';
import {useChekinSDK} from 'context/ChekinSDK';

type Props = UseMutationOptions<UserFinalizeResponse, Error, OAuthCallbackParams>;
function useGoogleOAuthCallbackMutation(options: Props = {}) {
  const {oauthGoogleCallback} = useChekinSDK();

  return useMutation<UserFinalizeResponse, Error, OAuthCallbackParams>(
    payload => oauthGoogleCallback(payload),
    options,
  );
}

export {useGoogleOAuthCallbackMutation};
